"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectInstanceContext = void 0;
const NetRef_1 = require("./NetRef");
class ProjectInstanceContext {
    constructor(netRefCtx = new NetRef_1.NetRefCtx()) {
        this.netRefCtx = netRefCtx;
    }
}
exports.ProjectInstanceContext = ProjectInstanceContext;
//# sourceMappingURL=ProjectInstanceContext.js.map